// src/index.tsx

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

// Suppress known ResizeObserver errors from triggering the dev overlay
window.addEventListener('error', e => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message.includes('ResizeObserver')
  ) {
    e.stopImmediatePropagation();
  }
});

const originalError = console.error;
console.error = (...args) => {
  if (
    args.length > 0 && 
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  originalError.call(console, ...args);
};


// Check if user details exist in local storage
const user = localStorage.getItem("userDetails");
const initialState = {
  auth: {
    isAuthenticated: !!user, // Set isAuthenticated based on presence of user details
    user: user ? JSON.parse(user) : null,
  },
};

// Render the root component with Redux store and BrowserRouter
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// Measure performance using reportWebVitals
reportWebVitals();
